import { render, staticRenderFns } from "./anime.vue?vue&type=template&id=3c08f0b9&scoped=true&"
import script from "./anime.vue?vue&type=script&lang=js&"
export * from "./anime.vue?vue&type=script&lang=js&"
import style0 from "./anime.vue?vue&type=style&index=0&id=3c08f0b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c08f0b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/magonxesp/repos/RandomAnimePicker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c08f0b9')) {
      api.createRecord('3c08f0b9', component.options)
    } else {
      api.reload('3c08f0b9', component.options)
    }
    module.hot.accept("./anime.vue?vue&type=template&id=3c08f0b9&scoped=true&", function () {
      api.rerender('3c08f0b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/anime/anime.vue"
export default component.exports